// @spec POL-STR-041
// Compliance dashboard route

import { createFileRoute } from '@tanstack/react-router';

import { ControlImplementationDashboardPage } from '@/features/controls/components/ControlImplementationDashboardPage';

export const Route = createFileRoute('/_authenticated/policies/compliance-dashboard')({
  component: ControlImplementationDashboardPage,
});
